import { Button, type ButtonProps } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { useRouter } from "next/router";
import { useState } from "react";

interface EditButtonProps extends ButtonProps {
  projectId: string;
}

const EditButton = ({ projectId, ...props }: EditButtonProps) => {
  const [loading, setLoading] = useState(false);

  const router = useRouter();

  const redirectToEdit = async () => {
    setLoading(true);
    await router.push({ pathname: "/projects/edit", query: { id: projectId } });
    setLoading(false);
  };

  return (
    <Button
      colorScheme="grey"
      isLoading={loading}
      leftIcon={<Icon name="pencil-01" color="grey" />}
      onClick={redirectToEdit}
      variant="outline"
      {...props}
    >
      {t`Edit details`}
    </Button>
  );
};

export default EditButton;
